import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-buses-policies',
  templateUrl: './buses-policies.component.html',
  styleUrls: [
    '../policies-detail/policies-detail.component.sass'
  ],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BusesPoliciesComponent {

  @Input() titleClass: string;

  public collapseFirst: boolean = false;
  public collapseSecond: boolean = false;
  public collapseImportant: boolean = false;

  constructor() { }

  public toggleFirst(): void {
    this.collapseFirst = !this.collapseFirst;
  }

  public toggleSecond(): void {
    this.collapseSecond = !this.collapseSecond;
  }

  public toggleImportant(): void {
    this.collapseImportant = !this.collapseImportant;
  }

}
